// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"92":"6bfcc9b5cbe900cf8099","358":"4082bba64231ad304a88"}[chunkId] + ".chunk.js";
};